<template>

  <div class="container">
    <header>
      <TopNavi :profile_name="this.$store.getters.profileGetName" />
    </header>


    <router-view></router-view>

  </div>
</template>

<script>

import TopNavi from '../../components/forum/TopNavi.vue';
import axios from '@/axios'

export default {
  components:{
    TopNavi,
  },

  created() {
    this.getCategories()
  },

  methods: {
    getCategories() {
      console.log('APP: getCategories');
      let _this = this;
      let params = new URLSearchParams();

      axios({
        url: "forum/categoriesGet",
        params: params,
      })
          .then(function(response) {
            _this.$store.commit("categoriesSet", response.data);
          })
          .catch(function() { console.log('Error: getMenu.'); });

    }
  }
}
</script>